import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./Button.module.css";
import { Link } from "react-router-dom";
import { IconProp } from '@fortawesome/fontawesome-svg-core';

// Define the props that the Input component will accept
interface InputProps {
    href?: string;
    name: string;
    text: string;
    type: string;
    wnum?: number;
    onClick?: () => void;
    iconPath?: IconProp; // Optional icon prop
}

const Button: React.FC<InputProps> = ({ href, name, text, type, wnum = 260, onClick, iconPath }) => {
    // divid by 8 and 4
    const width: string = `${wnum}px`;

    let padding: string = `${wnum / 8}px ${wnum / 4}px`;
    return href ? (
        <Link to={`/${href}`} className={name} type={type}>
            <button id={name} style={{ width, padding }} className={styles.ctaButton} onClick={onClick}>
                {iconPath ? (
                    <FontAwesomeIcon icon={iconPath} size="2x"  />
                ) : (
                    <p>{text}</p>
                )}
            </button>
        </Link>
    ) : (
        <button id={name} style={{ width, padding }} className={styles.ctaButton} onClick={onClick}>
            {iconPath ? (
                <FontAwesomeIcon icon={iconPath} size="2x" />
            ) : (
                <p>{text}</p>
            )}
        </button>
    );
};

export default Button;